import React from "react";
import FilterContent from "./components/Filter";

class AddContent extends React.Component {
    render() {
        const { stepCompleted } = this.props;
        return stepCompleted == 1 ? <FilterContent {...this.props} /> : null;
    }
}

export default AddContent;
